export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const DELETED_ITEMS = 'DELETED_ITEMS';
export const DETAILED_MAPPING_LOADED = 'DETAILED_MAPPING_LOADED';
export const SET_DUPLICATED_KEY_OBJECT = 'SET_DUPLICATED_KEY_OBJECT';
export const ERROR_DATA_MAPPINGS = 'ERROR_DATA_MAPPINGS';
export const ERROR_DATA_SUBCATEGORIES = 'ERROR_DATA_SUBCATEGORIES';
export const ERROR_DETAILED_MAPPINGS = 'ERROR_DETAILED_MAPPINGS';
export const LOAD_DETAILED_MAPPING = 'LOAD_DETAILED_MAPPING';
export const LOAD_MAPPINGS = 'FIND_MAPPINGS';
export const LOAD_SUB_CATEGORIES = 'LOAD_SUB_CATEGORIES';
export const MAPPINGS_LOADED = 'MAPPINGS_LOADED';
export const RESET = 'RESET';
export const RESET_MAPPINGS = 'RESET_MAPPINGS';
export const SAVED_MAPPINGS = 'SAVED_MAPPINGS';
export const SET_AGENCY = 'SET_AGENCY';
export const SUB_CATEGORIES_LOADED = 'SUB_CATEGORIES_LOADED';
